import { render } from "./UnreachablePoint.vue?vue&type=template&id=6dd9dbee"
import script from "./UnreachablePoint.vue?vue&type=script&lang=js"
export * from "./UnreachablePoint.vue?vue&type=script&lang=js"

import "./UnreachablePoint.vue?vue&type=style&index=0&id=6dd9dbee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__